import {UmpireImage} from '../umpire-image';
import {UmpireQuizQuestion} from '../umpire-quiz-question';

export interface UmpireQuizAnswer {
  type: 'quiz_answer';

  id: string | null;

  content: string | null;

  is_correct: boolean;

  image: Partial<UmpireImage> | null;

  quiz_question: Partial<UmpireQuizQuestion> | null;
}
